<script lang="ts">
    import Compressor from "compressorjs";
    import Icon from "./Icon.svelte";

    export let data: string;
    export let required = true;

    required &&= data == "";
    let input: HTMLInputElement;
    let error: boolean = false;
    let drag: boolean = false;

    function take() {
        input.click();
    }

    function load() {
        if (input.files.length > 0)
            new Compressor(input.files[0], {
                convertSize: 100 * 1024,
                quality: 0.6,
                maxWidth: 800,
                success(blob) {
                    error = false;
                    const base64 = new FileReader();
                    base64.onloadend = () => {
                        data = base64.result.toString();
                    };
                    base64.readAsDataURL(blob);
                },
            });
    }

    function invalid() {
        error = true;
    }

    function drop(e: DragEvent) {
        input.files = e.dataTransfer.files;
        load();
        drag = false;
    }
</script>

<main
    on:click={take}
    on:drop|preventDefault={drop}
    on:dragover|preventDefault={() => (drag = true)}
    on:dragleave|preventDefault={() => (drag = false)}
    on:keypress={take}
    class:error
    class:drag
>
    <div class="icon">
        <Icon icon="camera-fill" />
    </div>
    <input
        bind:this={input}
        on:change={load}
        on:invalid|preventDefault={invalid}
        {required}
        type="file"
        accept="image/*"
        capture="environment"
        style="display: none;"
    />
    <img src={data} alt="" />
</main>

<style>
    main {
        width: 200px;
        height: 150px;
        text-align: center;
        border: dotted 1px grey;
        vertical-align: middle;
    }
    .drag {
        border: solid 2px grey;
        background: repeating-linear-gradient(
            45deg,
            grey,
            grey 5px,
            white 5px,
            white 10px
        );
        opacity: 0.5;
    }
    img {
        max-width: 100%;
        max-height: 100%;
    }
    .error {
        border: dashed 2px red;
    }
    .icon {
        position: absolute;
        display: block;
        z-index: -1;
        width: 200px;
        color: grey;
        font-size: xx-large;
        margin-top: 50px;
        pointer-events: none;
    }
    .error .icon {
        color: red;
    }
</style>
